import styles from './sizeRating.less';
import Radiorer from '../../../../../../components/radiorer';

export {styles};

export interface SizeRatingSize {
    id: number;
    name: string;
}

interface SizeRatingStyles {
    sizeRating?: string;
}

interface SizeRatingProps {
    size: number;
    sizes: SizeRatingSize[];
    onChange?: (size: number) => void;
    styles?: SizeRatingStyles;
}

interface SizeRatingState {
    size?: number;
}

export default class SizeRating extends React.PureComponent<SizeRatingProps, SizeRatingState> {

    constructor(props) {
        super(props);

        this.state = {size: this.props.size};

        this.onSizeClick = this.onSizeClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stars !== this.props.size) {
            this.setState({...this.state,
                size: this.props.size,
            });
        }
    }

    onSizeClick(ratingSize: SizeRatingSize) {
        this.setState({...this.state,
            size: ratingSize.id,
        }, () => {
            this.props.onChange?.(this.state.size);
        });
    }

    render() {
        return (
            <div className={classNames(styles.sizeRating, this.props.styles?.sizeRating)}>
                <div className={styles.sizeButtons}>
                    {this.props.sizes.map((size) =>
                        <Radiorer
                            key={size.id}
                            name={'rating'}
                            size={22}
                            onChange={() => this.onSizeClick(size)}
                            styles={{
                                radiorer: styles.sizeButton,
                            }}
                        />
                    )}
                </div>

                <div className={styles.sizeLabels}>
                    {this.props.sizes.map((size) =>
                        <div key={size.id} className={styles.sizeLabel}>{size.name}</div>
                    )}
                </div>
            </div>
        );
    }
}
